const footerNav = [
  { label: '速览索引', href: '#suolan' },
  { label: '同类盘点', href: '#pandian' },
  { label: '事件脉络', href: '#mailuo' },
  { label: '横向对比', href: '#duibi' },
  { label: '舆论现场', href: '#shengyin' },
  { label: '概念速查', href: '#cidian' },
  { label: '常见疑问', href: '#faq' },
];

export default function SiteFooter() {
  return (
    <footer className="bg-[#3d2a1c] py-12 text-cream/70">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center gap-2" aria-label="媚黑大赛 回到顶部">
              <span className="grid h-8 w-8 place-items-center rounded-lg bg-honey-400 font-display text-sm font-black text-ink">
                媚
              </span>
              <span className="font-display text-lg font-black tracking-wide text-paper">
                媚黑大赛
              </span>
            </a>
            <p className="mt-4 max-w-sm text-[13px] leading-relaxed text-cream/55">
              面向吃瓜观众的话题观察页：把媚黑大赛相关事件、类似案例与同类话题拉在一起做盘点对比，帮你更快建立完整视角，省下到处翻信息流的时间。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {['相关事件', '类似案例', '同类盘点', '横向对比'].map((k) => (
                <span key={k} className="rounded-full border border-cream/15 bg-cream/5 px-3 py-1 text-[11px] font-medium text-cream/50">
                  {k}
                </span>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="eyebrow text-honey-300">内容分区</h4>
            <ul className="mt-4 grid grid-cols-2 gap-2">
              {footerNav.map((n) => (
                <li key={n.href}>
                  <a href={n.href} className="inline-flex items-center gap-1.5 text-[13px] text-cream/65 transition-colors hover:text-honey-300">
                    <i className="ri-arrow-right-s-line text-honey-400/60" aria-hidden="true"></i>
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="eyebrow text-honey-300">阅读须知</h4>
            <div className="mt-4 rounded-lg border border-cream/10 bg-cream/5 p-4">
              <p className="text-[12px] leading-relaxed text-cream/60">
                本站为静态盘点与观点聚合页，内容为传播形态的观察归纳，用于理解同类话题的共通结构，不代表事实定论，也不指向任何具体个人。涉及个案请以权威官方与多方信源为准。
              </p>
            </div>
            <p className="mt-3 flex items-center gap-2 text-[12px] text-cream/45">
              <i className="ri-file-warning-line text-honey-300/70" aria-hidden="true"></i>
              不构成新闻、法律或任何实质结论，仅供浏览参考。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-cream/10 pt-6 sm:flex-row">
          <p className="text-[12px] text-cream/40">© 2026 媚黑大赛 · 话题观察站，保留所有权利。</p>
          <div className="flex items-center gap-4">
            <span className="inline-flex items-center gap-1.5 text-[12px] text-cream/40">
              <i className="ri-eye-line" aria-hidden="true"></i>
              页面静态展示 · 不收集信息
            </span>
            <a
              href="#top"
              aria-label="回到顶部"
              className="grid h-9 w-9 place-items-center rounded-full border border-cream/15 text-cream/60 transition-colors hover:bg-honey-400 hover:text-ink"
            >
              <i className="ri-arrow-up-line" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}